<template>
  <div
    class="nav-sub-item"
    :class="{en:$store.state.app.lang === 'en'}"
  >
    <div
      class="label"
      :class="{active: activeLevelTwoId === info.meta.id}"
    >
      <span class="text">{{ i18n.t(info.meta.title) }}</span>
      <span class="icon-arrow">
        <svg
          class="icon icon-user"
          aria-hidden="true"
        >
          <use xlink:href="#icon-youjiantou"></use>
        </svg>
      </span>
    </div>
    <div class="list-container">
      <LinkItem
        v-for="(item,index) in info.children"
        :key="index"
        :info="item"
        :infoId="info.meta.id"
      />
    </div>
  </div>
</template>

<script>
import i18n from '@/lang'
import { mapState } from 'vuex'
export default {
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      i18n
    }
  },
  computed: {
    ...mapState('nav', ['activeLevelTwoId'])
  }
}
</script>

<style lang="less" scoped>
.nav-sub-item {
  width: 100%;
  display: flex;
  justify-content: center;
  line-height: 24px;

  .label {
    width: 25.83%;
    text-align: right;
    &.active {
      color: @blue;
    }
    .icon-arrow {
      display: inline-block;
      margin: 0 43px 0 18px;
    }
  }
  .list-container {
    flex: 1 1 0%;
    display: flex;
    justify-content: flex-start;
    // align-items: center;
    flex-wrap: wrap;
    padding-left: 60px;
    border-left: 1px solid @grayLess40;
  }
}
</style>
